import { Link } from 'react-router-dom';
import { insightArticles } from '@/mocks/insights';

export default function Insights() {
  const [feature, ...rest] = insightArticles.slice(0, 3);

  return (
    <section id="insights" className="bg-background-50 sec">
      <div className="wrap">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12 md:mb-20" data-reveal>
          <h2 className="font-heading font-light uppercase text-foreground-950 leading-[1] tracking-[0.02em] text-[38px] md:text-6xl lg:text-[76px]">Notes on<br />strategy &amp; change.</h2>
          <Link to="/insights" className="label-xs text-foreground-600 hover:text-foreground-950 link-line pb-1 cursor-pointer whitespace-nowrap">All insights &rarr;</Link>
        </div>

        <article className="border-t border-foreground-950/15 pt-10 pb-12" data-reveal>
          <Link to={`/insights/${feature.slug}`} className="group grid grid-cols-1 lg:grid-cols-12 gap-x-8 gap-y-8 items-center cursor-pointer">
            <div className="lg:col-span-6 w-full aspect-[16/9] overflow-hidden rounded-[50%]">
              <img src={feature.cover} alt={`${feature.title} — AUREN insight`} title={feature.title} className="w-full h-full object-cover object-center" />
            </div>
            <div className="lg:col-span-5 lg:col-start-8">
              <span className="label-xs text-accent-700">Featured / {feature.category}</span>
              <h3 className="font-heading font-light uppercase text-foreground-950 group-hover:text-primary-500 transition-colors tracking-[0.03em] text-2xl md:text-[34px] leading-[1.1] mt-4">{feature.title}</h3>
              <p className="mt-4 text-[15px] leading-[1.6] text-foreground-700">{feature.summary}</p>
              <span className="mt-6 inline-flex items-center gap-4 label-xs text-foreground-950 whitespace-nowrap">
                Read the note
                <span className="circle-arrow inv-dark"><i className="ri-arrow-right-line" /></span>
              </span>
            </div>
          </Link>
        </article>

        {rest.map((a) => (
          <article key={a.slug} className="border-t border-foreground-950/15 last:border-b" data-reveal>
            <Link to={`/insights/${a.slug}`} className="group w-full grid grid-cols-[1fr_auto] md:grid-cols-12 gap-x-8 gap-y-2 items-center py-7 text-left cursor-pointer">
              <span className="label-xs text-foreground-600 md:col-span-2 col-span-2 md:col-auto">{a.category}</span>
              <span className="h-card text-foreground-950 group-hover:text-primary-500 transition-colors md:col-span-5">{a.title}</span>
              <span className="hidden md:block md:col-span-4 text-sm leading-[1.6] text-foreground-700">{a.summary}</span>
              <span className="md:col-span-1 justify-self-end"><span className="circle-arrow inv-dark text-foreground-950"><i className="ri-arrow-right-line" /></span></span>
            </Link>
          </article>
        ))}
      </div>
    </section>
  );
}